import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Inject,
  Input,
  HostListener,
} from "@angular/core";
import { LocationType } from "../models/location-type";
import { StandardService } from "../services/standard.service";
import { Category } from "../models/category";
import { FilteringGuide } from "../models/filteringGuide";
import { WebStorageService, LOCAL_STORAGE } from "ngx-webstorage-service";
import { CryptographyService } from "../services/cryptography.service";
import { Form, FormControl } from "@angular/forms";
import { source } from "@angular-devkit/schematics";
import {
  AllStandardsTabs,
  FilteringEnum,
  StandardListType,
  UserRoleEnum,
} from "../core/constant";
import { sortWithSelectedFirst, shouldShowSelectedDivider } from "../core/filter-utils";
import { ThemePalette } from "@angular/material/core";
import { timeStamp } from "console";
import { FilterList } from "../models/filterList";
import { A } from "@angular/cdk/keycodes";

@Component({
  selector: "app-view-all-standards-filter",
  templateUrl: "./view-all-standards-filter.component.html",
  styleUrls: ["./view-all-standards-filter.scss"],
})
export class ViewAllStandardsFilter implements OnInit {

  isCategoryDropdownOpen: boolean = false;
categorySearchText: string = '';
filteredCategories: any[] = [];

isLocationDropdownOpen: boolean = false;
locationSearchText: string = '';
filteredLocations: any[] = [];

isCountryDropdownOpen: boolean = false;
countrySearchText: string = '';
filteredCountries: any[] = [];
selectedCountryIds: number[] = [];

isExportModalOpen = false;
exportFilterList: FilteringGuide[] = [];
ExportselectedCountryIds: number[] = [];
isExportCategoryDropdownOpen = false;
isExportLocationDropdownOpen = false;
isExportCountryDropdownOpen = false;
exportCategorySearchText = "";
exportLocationSearchText = "";
exportCountrySearchText = "";
exportFilteredCategories: Category[] = [];
exportFilteredLocations: LocationType[] = [];
exportFilteredCountries: any[] = [];

countries: any[] = [];
  locationTypes: LocationType[] = [];
  categories: Category[] = [];
  equipmentTypes: any = [];
  filterList: FilteringGuide[] = [];
  filteringForCheckBox: FilteringGuide[] = [];
  selectedTabs: FilteringGuide = new FilteringGuide({
    type: FilteringEnum.FilterByStandardType,
    ids: [],
  });
  filtersWidth: string = "col-md-6";

  //styling
  tabColor: ThemePalette = "warn";
  globaltabcheck = false;
  equipmenttabcheck = false;
  buildingtabcheck = false;
  operationstabcheck = false;
  allStandardsTabCheck = false;
  markettabcheck = false;

  searchKey: string = '';

  @Output() searchApplied = new EventEmitter<string>();
  @Output() messageEvent = new EventEmitter<Array<FilteringGuide>>();
  @Output() exportListFilter = new EventEmitter<Array<FilteringGuide>>();
  @Output() countryListFilter = new EventEmitter<any>();
  @Input() isFromLocation: boolean;
   @Input() searchKeyFromParent: string = '';
   @Input() isExporting: boolean = false;

  constructor(
    public standardService: StandardService,
    @Inject(LOCAL_STORAGE)
    public storage: WebStorageService,
    private cryptographyService: CryptographyService
  ) {}

ngOnInit() {
  this.getMasterDataForFilteration();
  this.filterList = this.standardService.allStandardsFiltration.filterSet;
  
  // Find or create the tabs filter
  let existingTabsFilter = this.filterList.find(
    (i) => i.type === FilteringEnum.FilterByStandardType
  );
  
  if (existingTabsFilter) {
    // If exists but has multiple tabs, force to single tab
    if (existingTabsFilter.ids.length > 1) {
      // Keep only the first tab (or your preferred default)
      // existingTabsFilter.ids = [AllStandardsTabs.AllStandards]
      existingTabsFilter.ids  =  [AllStandardsTabs.AllStandards]
    
      localStorage.setItem("selectedTabs", JSON.stringify([AllStandardsTabs.AllStandards]));
       this.selectedTabs =  existingTabsFilter

    }
    console.log("ffff", existingTabsFilter)
    
    this.selectedTabs = existingTabsFilter;
  } else {

    // Create new with single default tab
    this.selectedTabs = new FilteringGuide({
      type: FilteringEnum.FilterByStandardType,
      ids: [AllStandardsTabs.AllStandards]  // Single tab only
    });
    
    this.filterList.push(this.selectedTabs);
    localStorage.setItem("selectedTabs", JSON.stringify([AllStandardsTabs.AllStandards]));
    this.standardService.allStandardsFiltration.filterSet = this.filterList;
  }
  
  // Set checkbox states
  this.buildingtabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.BuildingStandards);
  this.operationstabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.OperationsStandard);
  this.globaltabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.GlobalRecommendations);
  this.equipmenttabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.EquipmentStandards);
  this.allStandardsTabCheck = this.selectedTabs.ids.includes(AllStandardsTabs.AllStandards);
  this.markettabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.MarketStandards);

  this.ensureValidTabForBasicUser();

  if (this.standardService.allStandardsFiltration.countryId?.length) {
    this.selectedCountryIds = [...this.standardService.allStandardsFiltration.countryId];
  } else if (sessionStorage.getItem("selectedCountryID")) {
    this.selectedCountryIds = this.getEffectiveCountryIds();
  }

  this.filteredCategories = sortWithSelectedFirst([...this.categories], (id) =>
    !!this.setCheckedStateForCheckBoxes(FilteringEnum.FilterByCategory, id),
  );
}

  arraysEqual(a1, a2) {
    return JSON.stringify(a1) == JSON.stringify(a2);
  }

  displayEquipmentTypeFilter() {
    if (
      !this.standardService.allStandardsFiltration.filterSet.find(
        (i) => i.type == FilteringEnum.FilterByStandardType
      )
    )
      return true;
    if (
      this.standardService.allStandardsFiltration.filterSet.find(
        (i) =>
          i.type == FilteringEnum.FilterByStandardType &&
          (i.ids.includes(AllStandardsTabs.EquipmentStandards) ||
            i.ids.length == 0)
      )
    ) {
      // this.filtersWidth = "col-md-4";
      return true;
    } else {
      // this.filtersWidth = "col-md-6";
      return false;
    }
  }

  displayAllTabs() {
    if (
      !this.standardService.allStandardsFiltration.filterSet.find(
        (i) => i.type == FilteringEnum.FilterByStandardType
      )
    ) {
      this.filtersWidth = "col-md-4";
      return true;
    } else if (
      this.standardService.allStandardsFiltration.filterSet.find(
        (i) => i.type == FilteringEnum.FilterByStandardType && i.ids.length == 0
      )
    ) {
      this.filtersWidth = "col-md-4";
      return true;
    }
    this.filtersWidth = "col-md-6";
    return false;
  }
  setTabChecked(name) {
    let a;
    if (
      this.filterList.find((i) => i.type == FilteringEnum.FilterByStandardType)
    ) {
      a = this.filterList.find(
        (i) => i.type == FilteringEnum.FilterByStandardType
      ).ids;
    } else return;
    {
      // this.allStandardsTabCheck = false;
      // this.globaltabcheck = false;
      // this.buildingtabcheck = false;
      // this.operationstabcheck = false;
      // this.equipmenttabcheck = false;
      false;
    }
    switch (name) {
      case "global":
        if (a.includes(AllStandardsTabs.GlobalRecommendations)) {
          this.globaltabcheck = true;
          return true;
        }
        break;
      case "equipment":
        if (a.includes(AllStandardsTabs.EquipmentStandards)) {
          this.equipmenttabcheck = true;
          return true;
        }
        break;
      case "operations":
        if (a.includes(AllStandardsTabs.OperationsStandard)) {
          this.operationstabcheck = true;
          return true;
        }
        break;
      case "building":
        if (a.includes(AllStandardsTabs.BuildingStandards)) {
          this.buildingtabcheck = true;
          return true;
        }
        break;
      case "allStandards":
        if (a.includes(AllStandardsTabs.AllStandards)) {
          this.allStandardsTabCheck = true;

          return true;
          
        }
        break;
      case "market":
        if (a.includes(AllStandardsTabs.MarketStandards)) {
          this.markettabcheck = true;
          return true;
        }
        break;
      default:
        break;
    }

    // this.globaltabcheck = false;
    // this.buildingtabcheck = false;
    // this.operationstabcheck = false;
    // this.equipmenttabcheck = false;
    // false;

    return false;
  }

  setBuildingCheck() {
    return this.setTabChecked("building");
  }
  setOperationsCheck() {
    return this.setTabChecked("operations");
  }
  setGlobalCheck() {
    return this.setTabChecked("global");
  }
  setEquipmentCheck() {
    return this.setTabChecked("equipment");
  }
  setAllStandardsCheck() {
    return this.setTabChecked("allStandards");
  }
  setMarketCheck() {
    return this.setTabChecked("market");
  }

  getEffectiveUserRole(): number {
    if (sessionStorage.getItem("userRoleId")) {
      return this.cryptographyService.decryptData(
        sessionStorage.getItem("userRoleId"),
      );
    }
    return this.cryptographyService.decryptData(this.storage.get("userRole"));
  }

  showCountryFilter(): boolean {
    const role = this.getEffectiveUserRole();
    return (
      role !== UserRoleEnum.MarketAdmin && role !== UserRoleEnum.BasicUser
    );
  }

  showMarketStandardsTab(): boolean {
    return this.getEffectiveUserRole() !== UserRoleEnum.BasicUser;
  }

  ensureValidTabForBasicUser(): void {
    if (this.getEffectiveUserRole() !== UserRoleEnum.BasicUser) {
      return;
    }

    if (this.selectedTabs.ids.includes(AllStandardsTabs.MarketStandards)) {
      this.selectedTabs.ids = [AllStandardsTabs.OperationsStandard];
      this.buildingtabcheck = false;
      this.operationstabcheck = true;
      this.globaltabcheck = false;
      this.equipmenttabcheck = false;
      this.allStandardsTabCheck = false;
      this.markettabcheck = false;

      const tabsFilterIndex = this.filterList.findIndex(
        (i) => i.type === FilteringEnum.FilterByStandardType,
      );
      if (tabsFilterIndex >= 0) {
        this.filterList[tabsFilterIndex] = this.selectedTabs;
      }
      this.standardService.allStandardsFiltration.filterSet = this.filterList;
      localStorage.setItem(
        "selectedTabs",
        JSON.stringify(this.selectedTabs.ids),
      );
    }
  }

  setDefaultCountryForGlobalAdmin(): void {
    if (
      this.getEffectiveUserRole() !== UserRoleEnum.GlobalAdmin ||
      sessionStorage.getItem("selectedCountryID") ||
      this.standardService.allStandardsFiltration.countryId?.length ||
      this.selectedCountryIds.length ||
      !this.countries?.length
    ) {
      return;
    }

    this.selectedCountryIds = [this.countries[0].id];
    this.standardService.allStandardsFiltration.countryId = [
      this.countries[0].id,
    ];
  }

  getEffectiveCountryIds(): number[] {
    const sessionCountryId = sessionStorage.getItem("selectedCountryID");
    if (sessionCountryId) {
      return [Number(JSON.parse(sessionCountryId))];
    }

    const userRole = this.getEffectiveUserRole();
    if (
      userRole == UserRoleEnum.MarketAdmin ||
      userRole == UserRoleEnum.BasicUser
    ) {
      const stored = this.cryptographyService.decryptData(
        this.storage.get("countryId"),
      );
      return Array.isArray(stored) ? stored : [stored];
    }

    return [];
  }

  getMasterDataForFilteration() {
    const userRole = this.getEffectiveUserRole();
    this.standardService
      .GetMasterDataForAddNrbes(
        userRole,
        this.cryptographyService.decryptData(this.storage.get("userId"))
      )
      .subscribe((data: any) => {
        this.categories = data.categories;

        this.locationTypes = data.locationTypes;
        this.countries = data.countries;
        const effectiveCountryIds = this.getEffectiveCountryIds();
        if (effectiveCountryIds.length) {
          this.countries = this.countries.filter((x) =>
            effectiveCountryIds.includes(x.id),
          );
        }
        this.setFilteredCountries([...this.countries]);
        this.setDefaultCountryForGlobalAdmin();
        // this.equipmentTypes = data.equipmentTypes;

        let xfilterList = new FilterList();
        xfilterList.standardListType = StandardListType.GlobalEquipment;

        this.standardService
          .getEquipmentStandardChipset(xfilterList)
          .subscribe((data: any) => {
            this.equipmentTypes = data.equipmentTypes;
          });
      });
  }

  addFilter($event, id, filterParam,name,filterType) {
    this.sendAuthEvent(name, id, filterType,$event.checked);
    console.log("filter event", name)
    if (this.standardService.allStandardsFiltration.filterSet != null) {
      this.filterList = this.standardService.allStandardsFiltration.filterSet;
    }
    if ($event.checked) {
      let filterGuide = this.filterList.find((i) => i.type === filterParam);
      if (filterGuide != undefined) {
        if (!filterGuide.ids.includes(id)) {
          filterGuide.ids.push(id);
        }
      } else {
        let guide = new FilteringGuide();
        guide.type = filterParam;
        guide.ids.push(id);
        this.filterList.push(guide);
      }
    } else {
      let selectedFilter = this.filterList.find((i) => i.type === filterParam);
      if (selectedFilter != undefined && selectedFilter.ids.includes(id)) {
        let index = selectedFilter.ids.indexOf(id);
        selectedFilter.ids.splice(index, 1);
      }
      if (selectedFilter.ids.length == 0) {
        let i = this.filterList.findIndex((x) => x.type === filterParam);
        this.filterList.splice(i, 1);
      }
    }
    this.standardService.allStandardsFiltration.filterSet = this.filterList;
    this.refreshFilteredListForFilterParam(filterParam);
    // this.messageEvent.emit(this.filterList);
  }

  private setFilteredCategories(items: any[]): void {
    this.filteredCategories = sortWithSelectedFirst(items, (id) =>
      !!this.setCheckedStateForCheckBoxes(FilteringEnum.FilterByCategory, id),
    );
  }

  private setFilteredLocations(items: any[]): void {
    this.filteredLocations = sortWithSelectedFirst(items, (id) =>
      !!this.setCheckedStateForCheckBoxes(
        FilteringEnum.FilterByLocationType,
        id,
      ),
    );
  }

  private setFilteredCountries(items: any[]): void {
    this.filteredCountries = sortWithSelectedFirst(items, (id) =>
      this.selectedCountryIds.includes(id),
    );
  }

  private setExportFilteredCategories(items: any[]): void {
    this.exportFilteredCategories = sortWithSelectedFirst(items, (id) =>
      !!this.setExportCheckedStateForCheckBoxes(
        FilteringEnum.FilterByCategory,
        id,
      ),
    );
  }

  private setExportFilteredLocations(items: any[]): void {
    this.exportFilteredLocations = sortWithSelectedFirst(items, (id) =>
      !!this.setExportCheckedStateForCheckBoxes(
        FilteringEnum.FilterByLocationType,
        id,
      ),
    );
  }

  private setExportFilteredCountries(items: any[]): void {
    this.exportFilteredCountries = sortWithSelectedFirst(items, (id) =>
      this.ExportselectedCountryIds.includes(id),
    );
  }

  private refreshFilteredListForFilterParam(filterParam: number): void {
    if (filterParam === FilteringEnum.FilterByCategory && this.isCategoryDropdownOpen) {
      this.filterItems('category');
    } else if (
      filterParam === FilteringEnum.FilterByLocationType &&
      this.isLocationDropdownOpen
    ) {
      this.filterItems('location');
    }
  }

  private refreshExportFilteredListForFilterParam(filterParam: number): void {
    if (
      filterParam === FilteringEnum.FilterByCategory &&
      this.isExportCategoryDropdownOpen
    ) {
      this.filterExportItems('category');
    } else if (
      filterParam === FilteringEnum.FilterByLocationType &&
      this.isExportLocationDropdownOpen
    ) {
      this.filterExportItems('location');
    }
  }

  private refreshCountryFilteredList(): void {
    if (this.isCountryDropdownOpen) {
      this.filterItems('country');
    }
  }

  private refreshExportCountryFilteredList(): void {
    if (this.isExportCountryDropdownOpen) {
      this.filterExportItems('country');
    }
  }

  applyFilters(){
    this.messageEvent.emit(this.filterList);

  }

  setCheckedStateForCheckBoxes(type, id) {
    this.filteringForCheckBox =
      this.standardService.allStandardsFiltration.filterSet;
    if (this.filteringForCheckBox != null) {
      let t = this.filteringForCheckBox.find((i) => i.type === type);
      if (t != undefined && t.ids.includes(id)) {
        return true;
      }
    }
  }

  // tabs filter
// tabs filter
tabClick(event): void {
  if (event.checked == false) {
    if (this.selectedTabs.ids.length == 1) {
      alert("Cannot de-select all tabs");
      // Re-check the checkbox that was just unchecked
      switch (event.source.name) {
        case "building":
          this.buildingtabcheck = true;
          break;
        case "operations":
          this.operationstabcheck = true;
          break;
        case "global":
          this.globaltabcheck = true;
          break;
        case "equipment":
          this.equipmenttabcheck = true;
          break;
        case "allStandards":
          this.allStandardsTabCheck = true;
          break;
        case "market":
          this.markettabcheck = true;
          break;
      }
      return;
    }
    switch (event.source.name) {
      case "building":
        if (this.selectedTabs.ids.includes(AllStandardsTabs.BuildingStandards)) {
          this.selectedTabs.ids.splice(
            this.selectedTabs.ids.indexOf(AllStandardsTabs.BuildingStandards),
            1
          );
        }
        break;
      case "operations":
        if (this.selectedTabs.ids.includes(AllStandardsTabs.OperationsStandard)) {
          this.selectedTabs.ids.splice(
            this.selectedTabs.ids.indexOf(AllStandardsTabs.OperationsStandard),
            1
          );
        }
        break;
      case "global":
        if (this.selectedTabs.ids.includes(AllStandardsTabs.GlobalRecommendations)) {
          this.selectedTabs.ids.splice(
            this.selectedTabs.ids.indexOf(AllStandardsTabs.GlobalRecommendations),
            1
          );
        }
        break;
      case "equipment":
        if (this.selectedTabs.ids.includes(AllStandardsTabs.EquipmentStandards)) {
          this.selectedTabs.ids.splice(
            this.selectedTabs.ids.indexOf(AllStandardsTabs.EquipmentStandards),
            1
          );
        }
        break;

        case 'allStandards':
      if (this.selectedTabs.ids.includes(AllStandardsTabs.AllStandards)) {
          this.selectedTabs.ids.splice(
            this.selectedTabs.ids.indexOf(AllStandardsTabs.AllStandards),
            1
          );
        }
        break;
      case "market":
        if (this.selectedTabs.ids.includes(AllStandardsTabs.MarketStandards)) {
          this.selectedTabs.ids.splice(
            this.selectedTabs.ids.indexOf(AllStandardsTabs.MarketStandards),
            1
          );
        }
        break;
    }
  } else {
    // Single selection: clear all existing tabs and select only the clicked one
    switch (event.source.name) {
      case "building":
        this.selectedTabs.ids = [AllStandardsTabs.BuildingStandards];
        this.buildingtabcheck = true;
        this.operationstabcheck = false;
        this.globaltabcheck = false;
        this.equipmenttabcheck = false;
        this.allStandardsTabCheck = false;
        this.markettabcheck = false;
        localStorage.setItem("selectedTabs", JSON.stringify(this.selectedTabs.ids));
        break;
      case "operations":
        this.selectedTabs.ids = [AllStandardsTabs.OperationsStandard];
         this.buildingtabcheck = false;
        this.operationstabcheck = true;
        this.globaltabcheck = false;
        this.equipmenttabcheck = false;
        this.allStandardsTabCheck = false;
        this.markettabcheck = false;
        localStorage.setItem("selectedTabs", JSON.stringify(this.selectedTabs.ids));
        break;
      case "global":
        this.selectedTabs.ids = [AllStandardsTabs.GlobalRecommendations];
        localStorage.setItem("selectedTabs", JSON.stringify(this.selectedTabs.ids));
         this.buildingtabcheck = false;
        this.operationstabcheck = false;
        this.globaltabcheck = true;
        this.equipmenttabcheck = false;
        this.allStandardsTabCheck = false;
        this.markettabcheck = false;
        break;
      case "equipment":
        this.selectedTabs.ids = [AllStandardsTabs.EquipmentStandards];
        localStorage.setItem("selectedTabs", JSON.stringify(this.selectedTabs.ids));
        break;
      case "allStandards":
        this.selectedTabs.ids = [AllStandardsTabs.GlobalRecommendations,AllStandardsTabs.BuildingStandards,AllStandardsTabs.OperationsStandard];
        this.buildingtabcheck = false;
        this.operationstabcheck = false;
        this.globaltabcheck = false;
        this.equipmenttabcheck = false;
        this.allStandardsTabCheck = true;
        this.markettabcheck = false;
      
        localStorage.setItem("selectedTabs", JSON.stringify(this.selectedTabs.ids));
        break;
      case "market":
        this.selectedTabs.ids = [AllStandardsTabs.MarketStandards];
        this.buildingtabcheck = false;
        this.operationstabcheck = false;
        this.globaltabcheck = false;
        this.equipmenttabcheck = false;
        this.allStandardsTabCheck = false;
        this.markettabcheck = true;
        localStorage.setItem("selectedTabs", JSON.stringify(this.selectedTabs.ids));
        break;
      default:
        break;
    }
  }
  
  // Update the individual tab check states based on selectedTabs.ids
  // this.buildingtabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.BuildingStandards);
  // this.operationstabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.OperationsStandard);
  // this.globaltabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.GlobalRecommendations);
  // this.equipmenttabcheck = this.selectedTabs.ids.includes(AllStandardsTabs.EquipmentStandards);
  // this.allStandardsTabCheck = this.selectedTabs.ids.includes(AllStandardsTabs.AllStandards);
  let indexOfTabsGuideInFilterList = -1;
  let idx = 0;
  for (let a of this.filterList) {
    if (a.type == FilteringEnum.FilterByStandardType) {
      indexOfTabsGuideInFilterList = idx;
    }
    idx = idx + 1;
  }
  if (indexOfTabsGuideInFilterList == -1) {
    this.filterList.push(this.selectedTabs);
  } else {
    this.filterList[indexOfTabsGuideInFilterList] = this.selectedTabs;
  }
  this.standardService.allStandardsFiltration.filterSet = this.filterList;
  void 0;
  this.messageEvent.emit(this.filterList);
}
  // tabClick(event): void {
  //   if (event.checked == false) {
  //     if (this.selectedTabs.ids.length == 1) {
  //       alert("Cannot de-select all tabs");
  //       this.setGlobalCheck();
  //       location.reload();
  //       return;
  //     }
  //     switch (event.source.name) {
  //       case "building":
  //         if (
  //           this.selectedTabs.ids.includes(AllStandardsTabs.BuildingStandards)
  //         ) {
  //           this.selectedTabs.ids.splice(
  //             this.selectedTabs.ids.indexOf(AllStandardsTabs.BuildingStandards),
  //             1
  //           );
  //         }
  //         break;
  //       case "operations":
  //         if (
  //           this.selectedTabs.ids.includes(AllStandardsTabs.OperationsStandard)
  //         ) {
  //           this.selectedTabs.ids.splice(
  //             this.selectedTabs.ids.indexOf(
  //               AllStandardsTabs.OperationsStandard
  //             ),
  //             1
  //           );
  //         }
  //         break;
  //       case "global":
  //         if (
  //           this.selectedTabs.ids.includes(
  //             AllStandardsTabs.GlobalRecommendations
  //           )
  //         ) {
  //           this.selectedTabs.ids.splice(
  //             this.selectedTabs.ids.indexOf(
  //               AllStandardsTabs.GlobalRecommendations
  //             ),
  //             1
  //           );
  //         }
  //         break;
  //       case "equipment":
  //         if (
  //           this.selectedTabs.ids.includes(AllStandardsTabs.EquipmentStandards)
  //         ) {
  //           this.selectedTabs.ids.splice(
  //             this.selectedTabs.ids.indexOf(
  //               AllStandardsTabs.EquipmentStandards
  //             ),
  //             1
  //           );
  //         }
  //         break;
  //       default:
  //         break;
  //     }
  //   } else {
  //     switch (event.source.name) {
  //       case "building":
  //         if (
  //           this.selectedTabs.ids.includes(AllStandardsTabs.BuildingStandards)
  //         ) {
  //         } else {
  //           if (
  //             this.selectedTabs.ids.includes(
  //               AllStandardsTabs.EquipmentStandards
  //             )
  //           ) {
  //             this.selectedTabs.ids.splice(
  //               this.selectedTabs.ids.indexOf(
  //                 AllStandardsTabs.EquipmentStandards
  //               ),
  //               1
  //             );
  //           }
  //           this.selectedTabs.ids.push(AllStandardsTabs.BuildingStandards);
  //           localStorage.setItem(
  //             "selectedTabs",
  //             JSON.stringify(this.selectedTabs.ids)
  //           );
  //         }
  //         break;
  //       case "operations":
  //         if (
  //           this.selectedTabs.ids.includes(AllStandardsTabs.OperationsStandard)
  //         ) {
  //         } else {
  //           if (
  //             this.selectedTabs.ids.includes(
  //               AllStandardsTabs.EquipmentStandards
  //             )
  //           ) {
  //             this.selectedTabs.ids.splice(
  //               this.selectedTabs.ids.indexOf(
  //                 AllStandardsTabs.EquipmentStandards
  //               ),
  //               1
  //             );
  //           }
  //           this.selectedTabs.ids.push(AllStandardsTabs.OperationsStandard);
  //           localStorage.setItem(
  //             "selectedTabs",
  //             JSON.stringify(this.selectedTabs.ids)
  //           );
  //         }
  //         break;
  //       case "global":
  //         if (
  //           this.selectedTabs.ids.includes(
  //             AllStandardsTabs.GlobalRecommendations
  //           )
  //         ) {
  //         } else {
  //           if (
  //             this.selectedTabs.ids.includes(
  //               AllStandardsTabs.EquipmentStandards
  //             )
  //           ) {
  //             this.selectedTabs.ids.splice(
  //               this.selectedTabs.ids.indexOf(
  //                 AllStandardsTabs.EquipmentStandards
  //               ),
  //               1
  //             );
  //           }
  //           this.selectedTabs.ids.push(AllStandardsTabs.GlobalRecommendations);
  //           localStorage.setItem(
  //             "selectedTabs",
  //             JSON.stringify(this.selectedTabs.ids)
  //           );
  //         }
  //         break;
  //       case "equipment":
  //         this.selectedTabs.ids = [AllStandardsTabs.EquipmentStandards];
  //         break;
  //       default:
  //         break;
  //     }
  //   }
  //   let indexOfTabsGuideInFilterList = -1;
  //   let idx = 0;
  //   for (let a of this.filterList) {
  //     if (a.type == FilteringEnum.FilterByStandardType) {
  //       indexOfTabsGuideInFilterList = idx;
  //     }
  //     idx = idx + 1;
  //   }
  //   if (indexOfTabsGuideInFilterList == -1) {
  //     this.filterList.push(this.selectedTabs);
  //   } else {
  //     this.filterList[indexOfTabsGuideInFilterList] = this.selectedTabs;
  //   }
  //   this.standardService.allStandardsFiltration.filterSet = this.filterList;
  //   void 0;
  //   this.messageEvent.emit(this.filterList);
  //   // this.messageEvent.emit(this.filterList);
  // }

   async sendAuthEvent(filterName, filterID, filterType,isChecked) {
    this.standardService
      .recordSearchEvent([
        {
          eventType: "GRSFilters",
          filterName: filterName,
          filterID: filterID,
          filterType: filterType,
          isChecked: isChecked,
          session: JSON.parse(localStorage.getItem("NRBA_SESSION")).value,
        },
      ])
      .subscribe({ next: () => void 0, error: () => void 0 });
  }



@HostListener('document:click', ['$event'])

onClickOutside(event: MouseEvent) {

  const target = event.target as HTMLElement;

 

  // Close category dropdown

  if (!target.closest('.mcd-filter-dropdown-wrapper')) {

    this.isCategoryDropdownOpen = false;

  }

 

  // Close location dropdown

  if (!target.closest('.mcd-filter-dropdown-wrapper')) {

    this.isLocationDropdownOpen = false;

  }

  if(!target.closest('.mcd-filter-dropdown-wrapper')) {

    this.isCountryDropdownOpen = false;

  }

}



toggleDropdown(dropdownType: 'country' | 'location' | 'category') {

  // Close all dropdowns first

  this.isCountryDropdownOpen = false;

  this.isLocationDropdownOpen = false;

  this.isCategoryDropdownOpen = false;



  // Open the requested dropdown

  switch(dropdownType) {

    case 'country':

      this.isCountryDropdownOpen = true;

      this.countrySearchText = '';

      this.setFilteredCountries([...this.countries]);

      break;

    case 'location':

      this.isLocationDropdownOpen = true;

      this.locationSearchText = '';

      this.setFilteredLocations([...this.locationTypes]);

      break;

    case 'category':

      this.isCategoryDropdownOpen = true;

      this.categorySearchText = '';

      this.setFilteredCategories([...this.categories])

      break;

  }

}



// Single filter function

filterItems(type: 'country' | 'location' | 'category') {

  let searchTerm: string;

 

  if (type === 'country') {

    searchTerm = this.countrySearchText.toLowerCase();

    this.setFilteredCountries(this.countries.filter(country =>

      country.name.toLowerCase().includes(searchTerm)

    ));

  } else if (type === 'location') {

    searchTerm = this.locationSearchText.toLowerCase();

    this.setFilteredLocations(this.locationTypes.filter(location =>

      location.name.toLowerCase().includes(searchTerm)

    ));

  } else { // category

    searchTerm = this.categorySearchText.toLowerCase();

    this.setFilteredCategories(this.categories.filter(category =>

      category.name.toLowerCase().includes(searchTerm)

    ));

  }

}



// Single get selected items count

getSelectedItemsCount(type: 'country' | 'location' | 'category'): any {

  let items: any[];

  let checkboxType: number;

 

  if (type === 'country') {

    return this.selectedCountryIds

      .map(id => this.countries.find(c => c.id === id)?.name)

      .filter(Boolean);

  } else if (type === 'location') {

    items = this.locationTypes;

    checkboxType = 1;

  } else { // category

    items = this.categories;

    checkboxType = 2;

  }

 

  return items

    .filter(item => this.setCheckedStateForCheckBoxes(checkboxType, item.id))

    .map(item => item.name);

}



// Single display text function

getDisplayText(type: 'country' | 'location' | 'category'): string {

  const selected = this.getSelectedItemsCount(type);

  if (selected.length === 0) return '';

  if (selected.length === 1) return `:${selected[0]}`;

  return ` : ${selected[0]} +${selected.length - 1}`;

}

showFilterClearButton(type: 'country' | 'location' | 'category'): boolean {
  if (type === 'country') {
    return this.shouldShowCountryClearButton();
  }
  return this.getSelectedItemsCount(type).length > 0;
}

shouldShowCountryClearButton(): boolean {
  if (!this.selectedCountryIds.length) {
    return false;
  }
  if (this.selectedCountryIds.length === 1) {
    const countryId = this.selectedCountryIds[0];
    if (countryId === 0) {
      return false;
    }
    const countryName = this.countries.find((c) => c.id === countryId)?.name;
    if (countryName?.toLowerCase() === 'all countries') {
      return false;
    }
  }
  return true;
}

shouldShowCountryFilterHighlight(): boolean {
  return (
    this.getSelectedItemsCount('country').length > 0 &&
    this.shouldShowCountryClearButton()
  );
}



// Close dropdown

closeDropdown(type: 'country' | 'location' | 'category') {

  switch(type) {

    case 'country': this.isCountryDropdownOpen = false; break;

    case 'location': this.isLocationDropdownOpen = false; break;

    case 'category': this.isCategoryDropdownOpen = false; break;

  }

}
  onSearch(key:any) {
  this.searchKey = key.value;
    this.searchApplied.emit( this.searchKey);
  }

  openExportModal(): void {
    this.isExportModalOpen = true;
    this.setExportFilteredCategories([...this.categories]);
    this.setExportFilteredLocations([...this.locationTypes]);
    this.setExportFilteredCountries([...this.countries]);
  }

  closeExportModal(): void {
    this.isExportModalOpen = false;
    this.isExportCategoryDropdownOpen = false;
    this.isExportLocationDropdownOpen = false;
    this.isExportCountryDropdownOpen = false;
    this.exportFilterList = [];
    this.ExportselectedCountryIds = [];
  }

  toggleExportDropdown(dropdownType: "category" | "location" | "country"): void {
    this.isExportCategoryDropdownOpen =
      dropdownType === "category" ? !this.isExportCategoryDropdownOpen : false;
    this.isExportLocationDropdownOpen =
      dropdownType === "location" ? !this.isExportLocationDropdownOpen : false;
    this.isExportCountryDropdownOpen =
      dropdownType === "country" ? !this.isExportCountryDropdownOpen : false;

    if (this.isExportCategoryDropdownOpen) {
      this.exportCategorySearchText = "";
      this.setExportFilteredCategories([...this.categories]);
    }
    if (this.isExportLocationDropdownOpen) {
      this.exportLocationSearchText = "";
      this.setExportFilteredLocations([...this.locationTypes]);
    }
    if (this.isExportCountryDropdownOpen) {
      this.exportCountrySearchText = "";
      this.setExportFilteredCountries([...this.countries]);
    }
  }

  filterExportItems(type: "category" | "location" | "country"): void {
    if (type === "category") {
      const searchTerm = this.exportCategorySearchText.toLowerCase();
      this.setExportFilteredCategories(
        this.categories.filter((category) =>
          category.name.toLowerCase().includes(searchTerm),
        ),
      );
    } else if (type === "location") {
      const searchTerm = this.exportLocationSearchText.toLowerCase();
      this.setExportFilteredLocations(
        this.locationTypes.filter((location) =>
          location.name.toLowerCase().includes(searchTerm),
        ),
      );
    } else {
      const searchTerm = this.exportCountrySearchText.toLowerCase();
      this.setExportFilteredCountries(
        this.countries.filter((country) =>
          country.name.toLowerCase().includes(searchTerm),
        ),
      );
    }
  }

  addExportFilter($event, id, filterParam, name, type): void {
    if ($event.checked) {
      let filterGuide = this.exportFilterList.find((i) => i.type === filterParam);
      if (filterGuide != undefined) {
        if (!filterGuide.ids.includes(id)) {
          filterGuide.ids.push(id);
        }
      } else {
        let guide = new FilteringGuide();
        guide.type = filterParam;
        guide.ids.push(id);
        this.exportFilterList.push(guide);
      }
    } else {
      let selectedFilter = this.exportFilterList.find((i) => i.type === filterParam);
      if (selectedFilter != undefined && selectedFilter.ids.includes(id)) {
        let index = selectedFilter.ids.indexOf(id);
        selectedFilter.ids.splice(index, 1);
      }
      if (selectedFilter && selectedFilter.ids.length == 0) {
        let i = this.exportFilterList.findIndex((x) => x.type === filterParam);
        if (i > -1) {
          this.exportFilterList.splice(i, 1);
        }
      }
    }
    this.refreshExportFilteredListForFilterParam(filterParam);
  }

  setExportCheckedStateForCheckBoxes(type, id): boolean {
    if (this.exportFilterList != null && this.exportFilterList.length > 0) {
      let t = this.exportFilterList.find((i) => i.type === type);
      if (t != undefined && t.ids.includes(id)) {
        return true;
      }
    }
    return false;
  }

  getExportSelectedItemsCount(type: "location" | "category"): string[] {
    let items: any[];
    let checkboxType: number;

    if (type === "location") {
      items = this.locationTypes;
      checkboxType = FilteringEnum.FilterByLocationType;
    } else {
      items = this.categories;
      checkboxType = FilteringEnum.FilterByCategory;
    }

    return items
      .filter((item) =>
        this.setExportCheckedStateForCheckBoxes(checkboxType, item.id),
      )
      .map((item) => item.name);
  }

  getExportDisplayText(type: "location" | "category"): string {
    const selected = this.getExportSelectedItemsCount(type);
    if (selected.length === 0) {
      return "";
    }
    if (selected.length === 1) {
      return `${selected[0]}`;
    }
    return `${selected[0]} +${selected.length - 1}`;
  }

  private isAllCountriesItem(countryId: number): boolean {
    if (countryId === 0) return true;
    const country = this.countries?.find((c) => c.id === countryId);
    return country?.name?.toLowerCase() === "all countries";
  }

  private getAllCountriesId(): number {
    const allObj = this.countries?.find(
      (c) => c.id === 0 || c.name?.toLowerCase() === "all countries"
    );
    return allObj ? allObj.id : 0;
  }

  isExportCountrySelected(countryId: number): boolean {
    return this.ExportselectedCountryIds.includes(countryId);
  }

  onExportCountrySelectionChange(event: any, countryId: number): void {
    const isAll = this.isAllCountriesItem(countryId);

    if (event.checked) {
      if (isAll) {
        this.ExportselectedCountryIds = [countryId];
      } else {
        this.ExportselectedCountryIds = this.ExportselectedCountryIds.filter(
          (id) => !this.isAllCountriesItem(id)
        );
        if (!this.ExportselectedCountryIds.includes(countryId)) {
          this.ExportselectedCountryIds.push(countryId);
        }
      }
    } else {
      const index = this.ExportselectedCountryIds.indexOf(countryId);
      if (index > -1) {
        this.ExportselectedCountryIds.splice(index, 1);
      }
      if (this.ExportselectedCountryIds.length === 0) {
        const defaultAllId = this.getAllCountriesId();
        this.ExportselectedCountryIds = [defaultAllId];
      }
    }
    this.refreshExportCountryFilteredList();
  }

  getExportCountryDisplayText(): string {
    if (this.ExportselectedCountryIds.length === 0) {
      return "";
    }

    const firstCountry = this.countries.find(
      (c) => c.id === this.ExportselectedCountryIds[0],
    );
    if (this.ExportselectedCountryIds.length === 1) {
      return firstCountry?.name ?? "";
    }
    return `${firstCountry?.name ?? ""} +${this.ExportselectedCountryIds.length - 1}`;
  }

  applyExportFilters(): void {
    this.isExportCategoryDropdownOpen = false;
    this.isExportLocationDropdownOpen = false;
    this.isExportCountryDropdownOpen = false;
    this.countryListFilter.emit(
      this.ExportselectedCountryIds.length > 0
        ? this.ExportselectedCountryIds
        : [],
    );
    this.exportListFilter.emit(this.exportFilterList);
    this.closeExportModal();
  }

 removeSelected(type: 'country' | 'location' | 'category', event?: Event) {
  event?.stopPropagation();
  event?.preventDefault();

  if (this.standardService.allStandardsFiltration.filterSet != null) {
    this.filterList = this.standardService.allStandardsFiltration.filterSet;
  }

  this.closeDropdown(type);

  if (type === 'country') {
    const defaultAllId = this.getAllCountriesId();
    this.selectedCountryIds = [defaultAllId];
    this.countrySearchText = "";
    this.standardService.allStandardsFiltration.countryId = [defaultAllId];
    this.setFilteredCountries([...this.countries]);
    this.messageEvent.emit(this.filterList);
    return;
  }

  let filterParam: number;
  if (type === 'category') {
    filterParam = FilteringEnum.FilterByCategory;
    this.categorySearchText = "";
    this.setFilteredCategories([...this.categories]);
  } else {
    filterParam = FilteringEnum.FilterByLocationType;
    this.locationSearchText = "";
    this.setFilteredLocations([...this.locationTypes]);
  }

  const filterGuide = this.filterList.find((i) => i.type === filterParam);
  if (filterGuide) {
    const index = this.filterList.indexOf(filterGuide);
    if (index !== -1) {
      this.filterList.splice(index, 1);
    }
  }

  this.standardService.allStandardsFiltration.filterSet = this.filterList;
  this.messageEvent.emit(this.filterList);
}

isCountrySelected(countryId: number): boolean {
  return this.selectedCountryIds.includes(countryId);
}

onCountryFilterChange(event: any, countryId: number): void {
  const isAll = this.isAllCountriesItem(countryId);

  if (event.checked) {
    if (isAll) {
      this.selectedCountryIds = [countryId];
    } else {
      this.selectedCountryIds = this.selectedCountryIds.filter(
        (id) => !this.isAllCountriesItem(id)
      );
      if (!this.selectedCountryIds.includes(countryId)) {
        this.selectedCountryIds.push(countryId);
      }
    }
  } else {
    const index = this.selectedCountryIds.indexOf(countryId);
    if (index >= 0) {
      this.selectedCountryIds.splice(index, 1);
    }
    if (this.selectedCountryIds.length === 0) {
      const defaultAllId = this.getAllCountriesId();
      this.selectedCountryIds = [defaultAllId];
    }
  }
  this.refreshCountryFilteredList();
}

applyCountryFilters(): void {
  this.standardService.allStandardsFiltration.countryId =
    this.selectedCountryIds.length > 0 ? [...this.selectedCountryIds] : null;
  this.isCountryDropdownOpen = false;
  this.messageEvent.emit(this.filterList);
}

showFilterDivider(items: any[], index: number, filterType: number): boolean {
  return shouldShowSelectedDivider(items, index, (id) =>
    !!this.setCheckedStateForCheckBoxes(filterType, id),
  );
}

showCountryFilterDivider(items: any[], index: number): boolean {
  return shouldShowSelectedDivider(items, index, (id) =>
    this.isCountrySelected(id),
  );
}

showExportFilterDivider(
  items: any[],
  index: number,
  filterType: number,
): boolean {
  return shouldShowSelectedDivider(items, index, (id) =>
    this.setExportCheckedStateForCheckBoxes(filterType, id),
  );
}

showExportCountryFilterDivider(items: any[], index: number): boolean {
  return shouldShowSelectedDivider(items, index, (id) =>
    this.isExportCountrySelected(id),
  );
}

}

